module.exports = __webpack_public_path__ + "media/images/logo_white-ad4114e6cba5e2cfc945b707a22c3216.png";